import { ReactElement, memo } from "react";
import get from 'lodash/get';
// import moment from 'moment';
import { BooleanField, BooleanFieldProps, FieldProps, TextFieldProps, useFieldValue, useRecordContext } from "react-admin";
import { Box, Divider, Typography } from "@mui/material";
import { format } from "date-fns";




type AccountStatusProps = { record?: any, source: string }
const AccountStatusField = ({ record }: AccountStatusProps) => {

    const status = record && (record.blockExpires > new Date() ? "retry blocked" : "ok");
    return (<Typography component="span" variant="body2">
        {status}
    </Typography>)

}


const sxSplitDateTime = {
    display: 'flex',
    flexDirection: "column",
    padding: "2px 8px",
    "& hr": {
        maxWidth: "60px"
    }

}

const sxIsOnline = {
    borderRadius: "6px",
    backgroundColor: 'error.main',
    color: 'error.contrastText'
}

const OnlineField = (props: TextFieldProps) => {
    const { source } = props;
    const record = useRecordContext(props)
    if (record) {

        const dateTime = (record: any) => {
            const value = get(record, source)
            if (value) {
                return [format(value, 'P'), format(value, "HH:mm:ss")]
            } else return [null, null]
        }
        const [date, time] = dateTime(record);
        return (
            <Box sx={{ ...sxSplitDateTime, ...record.isOnline && sxIsOnline }}            >
                <Typography component="div" variant="body2">
                    {date}
                </Typography>
                <Divider />
                <Typography component="div" variant="caption">
                    {time}
                </Typography>
            </Box>
        )
    }
    return null;

}

interface MultiSourceFieldProps extends Omit<FieldProps, "source"> {
    sources: string[],
    separator?: string,
    formatter?: (values: any[]) => string | ReactElement
}

export const MultiSourceField = (props: MultiSourceFieldProps) => {
    const { record, sources, separator = '/', formatter } = props;
    // formatter = formatter || (values => values.join(separator));
    if (record) {
        const values = sources.map(s => get(record, s));
        return (
            <Typography component="span" variant="body2">
                {values.join(separator)}
            </Typography>
        )
    } else {
        return null;
    }
}



const sxLocation = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "12ch",
}

const LocationField = (props: TextFieldProps) => {
    const value = useFieldValue(props);
    const coordinates = value?.coordinates;
    const handleClick = (e: any) => {
        e.stopPropagation();
    }
    // const classes = useStyles();
    if (coordinates) {
        const norm = `${coordinates[1]}, ${coordinates[0]}`;
        const href = `https://www.google.com/maps/search/?api=1&query=${norm}`;
        return (
            <Typography component="div" variant="body2" onClick={handleClick}>
                <a href={href} target="_blank">

                    <Typography component="div" variant="caption" sx={sxLocation} >{coordinates[1]}</Typography>
                    <Typography component="div" variant="caption" sx={sxLocation}>{coordinates[0]}</Typography>
                </a>
            </Typography>
        )
    } else return null
}


const ellipsisText = (text: string, len: number) => {

    const take = Math.min(text.length, len);
    return text.substr(0, take) + (take < text.length ? "..." : "");
}

interface EllipsesTextFieldProps extends TextFieldProps {
    ellipsis?: number
}

const EllipsesTextField = memo((props: EllipsesTextFieldProps) => {
    const { className, variant = "body2", component = "span", ellipsis = 22, emptyText } = props
    const rawValue = useFieldValue(props);
    const value = rawValue && ellipsisText(rawValue, ellipsis);

    return (
        <Typography component={component} variant={variant} className={className}>
            {value != null && typeof value !== 'string'
                ? JSON.stringify(value)
                : value || emptyText}
        </Typography>
    );
}
);


interface ColoredBooleanFieldProps extends BooleanFieldProps {
    trueColor: any,
    falseColor: any,
}

const ColoredBooleanField = (props: ColoredBooleanFieldProps) => {
    const { trueColor, falseColor } = props;
    const value = useFieldValue(props);
    return <BooleanField {...props} style={{ color: value ? trueColor : falseColor }} />
}



export { AccountStatusField, EllipsesTextField, OnlineField, LocationField, ColoredBooleanField }